import { ReactElement } from "react";
import { AppGlobalSearchResultItem, GlobalSearchScopeIdentifier } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { AppListItem } from "../../../Items/AppListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { generateTrackingId } from "client/Misc/utils";
import { TimeZone } from "client/DateAndTime/timezones";
import { useAppNavigationHandler } from "../../../Navigation/useAppNavigationHandler";

export type AppItemViewProps = {
	item: AppGlobalSearchResultItem;
	itemIndex: number;
	itemScope: GlobalSearchScopeIdentifier;
	timezone: TimeZone;
	tabIndex: number;
};

export const AppItemView = (props: AppItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		itemScope,
		timezone,
		tabIndex
	} = props;

	const {
		image,
		color,
		name,
		id,
		hitHighlights,
		maintenanceWindow,
		category,
		tags,
		tagsHitHighlights
	} = item;

	const openHandler: () => void = useAppNavigationHandler({
		id,
		parameters: item,
		maintenanceWindow,
		timezone,
		searchResult: item,
		itemScope
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("app-item", `|${id}`)}
			onClick={openHandler}
		>
			<AppListItem
				id={id}
				category={category}
				color={color}
				image={image}
				maintenanceWindow={maintenanceWindow}
				name={name}
				tags={tags}
				hitHighlights={hitHighlights}
				tagsHitHighlights={tagsHitHighlights}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
AppItemView.displayName = "AppItemView";
